import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import ThirdTabs from "../../components/tabs/ThirdTabs";
import { Collaborate_History } from "../../db_access/collaborate_history";
import CollaborateHistoryGrid from "./Dashboard/CollaborateHistoryGrid";

const CollaborateHistory = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("Received");
  const received = { label: "Received", value: "Received" };
  const sent = { label: "Sent", value: "Sent" };
  const tabs = [received, sent];
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">{t("Collaborate Dashboard")}</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Collaborate Dashboard")}</Typography>
          </Box>
        </Box>
      </PageTitleContainer>
      <Box sx={{ paddingY: 1 }}>
        <ThirdTabs options={tabs} selected={activeTab} setSelected={setActiveTab} />
      </Box>
      <Box sx={{ display: activeTab === received.value ? "block" : "none" }}>
        <CollaborateHistoryGrid title={"Received History"} getLogs={Collaborate_History.get_mine_received} />
      </Box>
      <Box sx={{ display: activeTab === sent.value ? "block" : "none" }}>
        <CollaborateHistoryGrid title={"Sent History"} getLogs={Collaborate_History.get_mine_sent} />
      </Box>
    </MainContainer>
  );
};
export default CollaborateHistory;
